import React from 'react';
import { useInfiniteQueryLinks } from 'app/hooks/useInfiniteQueryLinks';
export default function SeoLinks(_ref) {
  let {
    data
  } = _ref;
  const {
    prevLink,
    nextLink
  } = useInfiniteQueryLinks(data);
  return /*#__PURE__*/React.createElement(React.Fragment, null, prevLink ? /*#__PURE__*/React.createElement("a", {
    href: prevLink
  }, "Vorherige Seite") : null, nextLink ? /*#__PURE__*/React.createElement("a", {
    href: nextLink
  }, "N\xE4chste Seite") : null);
}